import * as React from 'react'
import RewardTitleImg from '../../../assets/images/reward/reward-title.png'
import EspectacularImg from '../../../assets/images/reward/espectacular.png'
import RewardProductImg from '../../../assets/images/reward/reward-product.png'
import RewardProductImgEc from '../../../assets/images/reward/reward-product-ec.png'
import RewardProductImgPe from '../../../assets/images/reward/reward-product-pe.png'
import RewardStage1ImgEc from '../../../assets/images/header/Premio-home.png'
import IndividualRewardImg from '../../../assets/images/reward/reward-individual.png'
import IndividualRewardImgPe from '../../../assets/images/reward/premio-pe.png'
import RewardStage2ImgEc from '../../../assets/images/reward/premio-fase2.png'
import RewardCollege from '../../../assets/images/reward/reward-college.png'
import { IndividualRewards, CollegeReward } from './rewards-info'
import './rewards.scss'

export const Rewards = () => {
  return (
    <section className="f-rewards" id="premios">
      <img
        src={RewardTitleImg}
        alt="premios"
        className="f-rewards__title-img"
      />

      <h2 className="f-rewards__title">¡Corre a participar!</h2>
      <h3 className="f-rewards__secondary-title">
        {
          process.env.LOCALE === "es-EC" ?
          <>
            <b>Serán 2 etapas,</b> donde podrás ganar desde un {' '}
            <b>Iphone XR hasta kits de productos Nosotras</b>
          </>
          : process.env.LOCALE === "es-PE" ?
          <>
            <p>Podrás ganar desde una tablet Lenovo</p> {' '}
            <b>hasta una fiesta con tu colegio</b>
          </>
          :
          <>
            <b>Serán 4 etapas,</b> donde podrás ganar desde un {' '}
            <b>Iphone hasta una fiesta con tu colegio</b>
          </>
        }
      </h3>
      <img
        src={EspectacularImg}
        alt="espectacular"
        className="f-rewards__secondary-title-img"
      />

      <div className="f-rewards__reward-product">
        <img
          src={process.env.LOCALE === "es-EC" ? RewardProductImgEc : process.env.LOCALE === "es-PE" ? RewardProductImgPe : RewardProductImg}
          alt="productos nosotras"
          className="f-rewards__reward-product__img"
        />
        <p className="f-rewards__reward-product__description">
          <b>¡Guarda tus empaques!</b> Comienza a ingresar tus claves
          personales,{' '}
          {
            process.env.LOCALE === "es-EC" ? <b>¡ganará la persona que más claves ingrese!</b> : <b>¡ganarán las personas y el colegio que más claves ingrese!</b>
          }
        </p>
      </div>

      <div className="f-rewards__rewards-content">
        <div className="f-rewards__rewards f-rewards__rewards--user-rewards">
          <img
            src={process.env.LOCALE === "es-EC" ? RewardStage1ImgEc : process.env.LOCALE === "es-PE" ? IndividualRewardImgPe : IndividualRewardImg}
            alt="premio individual"
            className="f-rewards__rewards__img"
          />
          {
            process.env.LOCALE === "es-EC" ?
            <h3 className="f-rewards__rewards__title">PREMIOS ETAPA 1</h3>
            : process.env.LOCALE === "es-PE" ?
            <h3 className="f-rewards__rewards__title">PREMIO INDIVIDUAL</h3>
            :
            <h3 className="f-rewards__rewards__title">PREMIOS INDIVIDUALES</h3>
          }

          <ul className="f-rewards__rewards__list">
            {IndividualRewards.map((item, index) => {
              return (
                <li className="f-rewards__rewards__list__item" key={index}>
                  <h4 className="f-rewards__rewards__list__item__title">
                    {item.title}
                  </h4>
                  <p className="f-rewards__rewards__list__item__description f-rewards__rewards__list__item__description--short">
                    {item.description}
                  </p>
                  <span className="f-rewards__rewards__list__item__winners">
                    {item.winnersNumber}
                  </span>
                </li>
              )
            })}
          </ul>
        </div>

        <div className="f-rewards__rewards">
          <img
            src={process.env.LOCALE === "es-EC" ? RewardStage2ImgEc : RewardCollege}
            alt="productos nosotras"
            className="f-rewards__rewards__img"
          />

          {
            process.env.LOCALE === "es-EC" ?
            <h3 className="f-rewards__rewards__title">PREMIOS ETAPA 2</h3>
            :
            <h3 className="f-rewards__rewards__title">PREMIO COLEGIOS</h3>
          }

          <ul className="f-rewards__rewards__list">
            {CollegeReward.map((item, index) => {
              return (
                <li className="f-rewards__rewards__list__item" key={index}>
                  <h4 className="f-rewards__rewards__list__item__title">
                    {item.title}
                  </h4>
                  <p className="f-rewards__rewards__list__item__description f-rewards__rewards__list__item__description--college">
                    {item.description}
                  </p>
                  <span className="f-rewards__rewards__list__item__winners">
                    {item.winnersNumber}
                  </span>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </section>
  )
}
